import comp from "./PrerequisiteSelection";
export default comp;
